const { LEOPARD_ACCOUNT, LEOPARD_ACCOUNT_ERROR } = require('../actions/types');

const initialState = {
  data: null,
  loading: true,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case LEOPARD_ACCOUNT:
      return {
        ...state,
        data: payload,
        loading: false,
      };

    case LEOPARD_ACCOUNT_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
